import React, { useEffect } from 'react';
import {
  FormControl,
  Grid,
  MenuItem,
  TextField,
} from '@material-ui/core';


const QuoteItemSubscriptionDiscount = ({
  item,
  index,
  formik,
  selectedDataSource
}) => {
  const {
    sku,
  } = item;

  const {
    handleBlur,
    touched,
    errors,
    setFieldValue,
  } = formik;

  const {
    productAttributes,
    productDiscounts,
    subscriptionOptions
  } = selectedDataSource;

  const {
    discountType,
    discount,
    fixedPrice,
    qty,
    subscriptionFrequency
  } = item;

  const isSubscriptionActive = parseInt(productAttributes?.subscription_active, 10) === 1;

  useEffect(() => {
    if (item.subscriptionDiscount === 'allCycles') {
      const newSubscriptionPrice = handleCalculateSubscriptionPrice();
      setFieldValue(`items[${index}].custom_subscription_price`, newSubscriptionPrice);
    }
  }, [discountType, discount, fixedPrice, qty, productAttributes?.savings]);

  useEffect(() => {
    if (subscriptionFrequency === 0 && item.subscriptionDiscount === 'allCycles') {
      setFieldValue(`items[${index}].subscriptionDiscount`, 'firstBill');
      setFieldValue(`items[${index}].custom_subscription_price`, null);
    }
  }, [subscriptionFrequency]);


  const handleChangeSubscriptionDiscount = (event) => {
    const { value } = event.target;
    setFieldValue(`items[${index}].subscriptionDiscount`, value);

    if (value === 'allCycles') {
      const subscriptionPrice = handleCalculateSubscriptionPrice();
      setFieldValue(`items[${index}].custom_subscription_price`, subscriptionPrice);
    } else if (value === 'firstBill') {
      setFieldValue(`items[${index}].custom_subscription_price`, null);
    }
  };

  const handleCalculateSubscriptionPrice = () => {
    const savings = +productAttributes?.savings || 0;

    const discountOptions = (productDiscounts || []).reduce((acc, option) => {
      const { price_type, price, sort_order } = option;

      acc[price_type] = [...(acc[price_type] || []), { price_type, price, sort_order }];
      acc[price_type].sort((a, b) => a.price - b.price);

      return acc;
    }, {});

    const selectedDiscount = discountOptions[discountType]?.find((option) => discount === option?.price && discountType === option?.price_type);
    let discountPrice;

    if (discountType && discount) {
      if (discountType === 'percent') {
        discountPrice = fixedPrice * discount / 100;
      } else {
        discountPrice = discount;
      }
    } else {
      discountPrice = (selectedDiscount?.price_type === 'percent')
        ? fixedPrice * (selectedDiscount?.price || 0) / 100
        : selectedDiscount?.price || 0;
    }

    return qty * Math.abs(fixedPrice - discountPrice - savings);
  };

  return (
    <Grid item xs={12} lg>
      <Grid item xs={12}>
        <FormControl variant="outlined" fullWidth>
          <TextField
            select
            name={`items[${index}].subscriptionDiscount`}
            variant="outlined"
            value={item.subscriptionDiscount || 'firstBill'}
            onChange={handleChangeSubscriptionDiscount}
            onBlur={handleBlur}
            disabled={!isSubscriptionActive || !subscriptionOptions?.length || !sku || subscriptionFrequency === 0}
            fullWidth
            label="Subscription discount"
            InputLabelProps={{
              shrink: true
            }}
            error={touched.items?.[index]?.subscriptionDiscount && !!errors.items?.[index]?.subscriptionDiscount}
            helperText={touched.items?.[index]?.subscriptionDiscount && errors.items?.[index]?.subscriptionDiscount}
          >
            <MenuItem value="firstBill">Only First Bill</MenuItem>
            <MenuItem value="allCycles">All Cycles</MenuItem>
          </TextField>
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default QuoteItemSubscriptionDiscount;
